import { PerformanceReviewStage, PerformanceReviewVersion } from '@/common/graphql';
import { getPerformanceReviewStageLabel } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

import { PerformanceReviewStageBadge } from '../../badge';
import type { ComboboxItemWithFormatted } from '../props';
import { SelectMultiple, type SelectMultipleProps } from '../SelectMultiple';

interface PerformanceReviewStageSelectMultipleProps
  extends Omit<SelectMultipleProps<ComboboxItemWithFormatted<PerformanceReviewStage>>, 'searchable' | 'value'> {
  value: Array<PerformanceReviewStage> | null | undefined;
}

const sortOrder = [
  PerformanceReviewStage.TargetSetting,
  PerformanceReviewStage.TargetEvaluation,
  PerformanceReviewStage.Closed,
];

const data: Array<ComboboxItemWithFormatted<PerformanceReviewStage>> =
  ObjectUtils.arrayFromEnumValues<PerformanceReviewStage>(PerformanceReviewStage)
    .sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b))
    .map(value => ({
      label: getPerformanceReviewStageLabel(value, PerformanceReviewVersion.Version_2),
      labelFormatted: <PerformanceReviewStageBadge stage={value} />,
      value,
    }));

export const PerformanceReviewStageSelectMultiple = ({
  placeholder = 'Select status',
  ...rest
}: PerformanceReviewStageSelectMultipleProps) => (
  <SelectMultiple
    {...rest}
    data={data}
    loading={false}
    multipleSelectedLabel={length => `${length} statuses`}
    placeholder={placeholder}
    searchable={false}
  />
);
